import { sizeOptionsOrDefault } from './utils';
import { Rectangle } from './Rectangle';
/**
 * A visual element that renders a terminator symbol with rounded ends.
 * Extends Rectangle and provides functionality for creating start/end flowchart shapes.
 */
export class Terminator extends Rectangle {
    /** @hidden */
    _drawPath() {
        const { width, height } = sizeOptionsOrDefault(this.options);
        const drawingElement = this.drawingElement;
        const r = height / 2;
        drawingElement
            .moveTo(r, 0)
            .lineTo(width - 2 * r, 0)
            .arcTo([width - 2 * r, height], r, r, false, false)
            .lineTo(r, height)
            .arcTo([r, 0], r, r, false, false)
            .close();
    }
}
